// extracted by mini-css-extract-plugin
export default {"container":"errorMessage_container__9t+7H"};